module.exports = __webpack_public_path__ + "img/163143.35fcd593.jpg";